import React, { FC } from 'react'
import { cn } from 'design-system'

interface DotsProps {
  className?: string
}

const Dots: FC<DotsProps> = ({ className }) => {
  return (
    <div className={cn('yd-loading-dots inline-block text-white', className)}>
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
  )
}

export default Dots
